<!-- 名录期刊列表页 -->
<template>
  <div class="box">
    <Header :pageTitle="''"></Header>
    <div class="list-box">
      <BkItem
        class="bk-list-item"
        v-for="item in list"
        :key="item.id"
        :cover="item.coverImg"
        :name="item.name"
        @click.native="toDetail(item.id)"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/detail/components/detailHeader.vue";
import BkItem from "@/views/mobileView/components/listItem/bkItem.vue";
export default {
  components: {
    Header,
    BkItem,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$apis.hundredServe
      .nfdetail({ orgId: this.$route.query.orgId })
      .then((result) => {
        this.list = [...result.orgPeriodicalList];
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    // 点击进入详情页
    toDetail(id) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "/appusesbaike",
        query: {
          item: 1,
          id,
          out,
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  padding: 56px 12px 12px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .list-box {
    padding: 14px 12px;
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    .bk-list-item {
      display: inline-block;
      margin-right: 13px;
      margin-bottom: 20px;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>